import * as styles from './Title.css';
import { PropsWithChildren } from 'react';

const Title = ({ children }: PropsWithChildren) => {
  return <h3 className={styles.container}>{children}</h3>;
};

export default Title;
